import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Banner } from '@shared/models/banner.model';
import { ApiResponse } from '@shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class BannerHttpService {

  constructor(private http: HttpClient) { }

  getAllBanner(): Observable<Banner[]> {
    return this.http.get<ApiResponse>(`/banner`).pipe(
      map(res => res.data)
    );
  }

}
